<div class="split-pane-container" #container>
  <div class="left-pane" #leftPane>
    <ng-content select="[left-pane]"></ng-content>
  </div>
  <div class="divider" (mousedown)="onDividerMouseDown($event)"></div>
  <div class="right-pane">
    <ng-content select="[right-pane]"></ng-content>
  </div>
</div>
